import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';


function Gallery() {
  const images = [
    'https://i.imgur.com/Xs1wfZ1.jpg',
    'https://i.imgur.com/0XFXWMW.jpg',
    'https://i.imgur.com/fUptoVM.jpg',
    'https://i.imgur.com/FQ2P84B.jpg',
    'https://i.imgur.com/a4xjF8g.jpg',
    'https://i.imgur.com/pLsZ3tr.jpg',
  ]

  return (
    <div className="gallery">
      <Carousel showStatus={false} infiniteLoop={true} itemPadding={[10, 10]}>
        {images.map((image, index) => (
          <div key={index}>
            <img src={image} alt={`Image ${index}` } />
          </div>
        ))}
      </Carousel>
    </div>
  );
}

export default Gallery;
